import React from 'react';
import PropTypes from 'prop-types';

import { WHITE } from '@constant/colors';

const Android = ({ width, color }) => (
  <svg width={width} height={width} viewBox="20 17 15 16">
    <path
      fill={color}
      fillRule="evenodd"
      d="M21.22 32.85c.37.067.808-.015 1.276-.27l8.213-4.482-2.39-2.41-7.1 7.162zM20.41 17.71c-.204.297-.322.704-.322 1.205V31.12c0 .49.112.89.307 1.182l7.24-7.304-7.224-7.287zM30.694 21.914l-8.197-4.46c-.455-.247-.882-.332-1.245-.275l7.068 7.128 2.374-2.394zM31.597 27.614l2.37-1.295c1.326-.723 1.325-1.904 0-2.625l-2.385-1.297-2.578 2.6 2.593 2.616z"
    />
  </svg>
);

Android.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

Android.defaultProps = {
  color: WHITE,
  width: 16,
};

export default Android;
